import { ResponseEnvelope } from 'infra/type'
import { emitter, EventType } from 'infra/events'

export class ApiError extends Error {
  status: number
  constructor(
    status: number,
    message: string = '예상치 못한 에러가 발생했어요!',
  ) {
    super(`${message} [${status}]`)
    this.status = status
  }
}

export const filterError = async (res: Response) => {
  // return if res is ok
  if (res.ok) return res
  // check if body exists
  let resJson: ResponseEnvelope
  try {
    resJson = await res.json()
  } catch {
    // 1) json body doesn't exist
    // NOTE(gogo): consider sending the error to bugsnag
    throw new ApiError(res.status)
  }
  // 2) json body does exist
  if (resJson.status === 401) {
    emitter.emit(EventType.TOKEN_INVALIDATED)
  }
  // 서버에서 따로 정상적인 에러 처리를 안 해줬을 때 두번째 옵션으로 대응
  throw new ApiError(
    resJson.status || res.status,
    resJson.message || JSON.stringify(resJson),
  )
}
